import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/components/login/index"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "home",
        component: () => import("@/components/home/index"),
        meta: { title: "首页", icon: "dashboard" },
      },
      // cms后台迭代 组织架构
      {
        path: "organizationalStructure",
        component: () =>
          import("@/components/organization/organizationalStructure/index.vue"),
      },

      //  部门管理
      {
        path: "divisionalManagement",
        component: () =>
          import("@/components/organization/divisionalManagement/index.vue"),
      },
      //  岗位管理
      {
        path: "postManagement",
        component: () =>
          import("@/components/organization/postManagement/index.vue"),
      },
      //  人员管理
      {
        path: "peopleManagement",
        component: () =>
          import("@/components/organization/peopleManagement/index.vue"),
      },
      //  合同管理
      {
        path: "contractManagement",
        component: () =>
          import("@/components/organization/contractManagement/index.vue"),
      },
      //  培训管理
      {
        path: "trainManagement",
        component: () =>
          import("@/components/organization/trainManagement/index.vue"),
      },
      //  奖惩管理
      {
        path: "rewardManagement",
        component: () =>
          import("@/components/organization/rewardManagement/index.vue"),
      },
      //  薪酬记录管理
      {
        path: "payment",
        component: () => import("@/components/organization/payment/index.vue"),
      },
    ],
  },

  {
    path: "/practitionerManagement",
    component: Layout,
    //  redirect: "/coreManagement/insurance",
    meta: { title: "从业者管理", icon: "people-fill" },
    children: [
      {
        path: "agentAudit",
        component: () =>
          import("@/components/practitionerManagement/agentAudit/index.vue"),
        meta: { title: "代理人审核", icon: "arrow-right" },
      },
      {
        path: "agentManagement",
        component: () =>
          import(
            "@/components/practitionerManagement/agentManagement/index.vue"
          ),
        meta: { title: "代理人管理", icon: "arrow-right" },
      },
      {
        path: "recruitmentManagement",
        component: () =>
          import(
            "../components/practitionerManagement/recruitmentManagement/recruitment/index.vue"
          ),
        meta: { title: "增员关系管理", icon: "people-fill" },
      },
      {
        path: "teamManagement",
        component: () =>
          import(
            "@/components/practitionerManagement/teamManagement/index.vue"
          ),
        meta: { title: "团队管理", icon: "arrow-right" },
      },
      {
        path: "chainStoreManagement",
        component: () =>
          import(
            "@/components/practitionerManagement/chainStoreManagement/index.vue"
          ),
        meta: { title: "连锁店管理", icon: "arrow-right" },
      },
      {
        path: "partnerManagement",
        component: () =>
          import(
            "@/components/practitionerManagement/partnerManagement/index.vue"
          ),
        meta: { title: "合伙人管理", icon: "arrow-right" },
      },
      {
        path: "eaStore",
        component: () =>
          import(
            "@/components/practitionerManagement/eaStoreManagment/index.vue"
          ),
        meta: { title: "EA门店管理", icon: "arrow-right" },
      },
    ],
  },
  {
    path: "/channelPolicyManagement",
    component: Layout,
    meta: { title: "渠道与政策管理", icon: "people-fill" },
    children: [
      {
        path: "brandManagement",
        component: () =>
          import(
            "@/components/channelPolicyManagement/brandManagement/index.vue"
          ),
        meta: { title: "品牌管理", icon: "arrow-right" },
      },
      {
        path: "insuranceCompany",
        component: () =>
          import(
            "@/components/channelPolicyManagement/InsuranceCompanyManagement/index.vue"
          ),
        meta: { title: "保险公司管理", icon: "arrow-right" },
      },
      {
        path: "agreement",
        component: () =>
          import(
            "@/components/channelPolicyManagement/InsuranceCompanyAgreement/index.vue"
          ),
        meta: { title: "保险公司协议", icon: "arrow-right" },
      },
      {
        path: "InsurancePolicy",
        //  component: () =>
        //    import(
        //      "@/components/channelPolicyManagement/InsurancePolicy/lifeInsurance/index.vue"
        //    ),
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "lifeInsurance",
        meta: { title: "险种政策管理", icon: "arrow-right" },
        children: [
          {
            path: "lifeInsurance",
            component: () =>
              import(
                "@/components/channelPolicyManagement/InsurancePolicy/lifeInsurance/index.vue"
              ),
            meta: { title: "人身险政策", icon: "arrow-right" },
          },
          {
            path: "nonmotorInsurance",
            component: () =>
              import(
                "@/components/channelPolicyManagement/InsurancePolicy/nonmotorInsurance/index.vue"
              ),
            meta: { title: "非车险政策", icon: "arrow-right" },
          },
          {
            path: "carInsurance",
            component: () =>
              import(
                "@/components/channelPolicyManagement/InsurancePolicy/carInsurance/index.vue"
              ),
            meta: { title: "车险政策", icon: "arrow-right" },
          },
        ],
      },
      {
        path: "commissionManagement",
        component: () =>
          import(
            "@/components/channelPolicyManagement/commissionManagement/index.vue"
          ),
        meta: { title: "结佣政策管理", icon: "arrow-right" },
      },
      {
        path: "activityManagement",
        component: () =>
          import(
            "@/components/channelPolicyManagement/activityManagement/index.vue"
          ),
        meta: { title: "推动方案管理", icon: "arrow-right" },
      },
      {
        path: "InsuranceCategoryManagement",
        component: () =>
          import(
            "@/components/channelPolicyManagement/InsuranceCategoryManagement/index.vue"
          ),
        meta: { title: "险种类别管理", icon: "arrow-right" },
      },
    ],
  },
  {
    path: "/productLibrary",
    component: Layout,
    meta: { title: "产品库", icon: "people-fill" },
    children: [
      {
        path: "JDproductList",
        meta: { title: "经代渠道产品", icon: "arrow-right" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "lifeInsurance",
            component: () =>
              import(
                "@/components/productLibrary/JDproductList/lifeInsurance/index.vue"
              ),
            meta: { title: "人身险", icon: "arrow-right" },
          },
          {
            path: "carInsurance",
            component: () =>
              import(
                "@/components/productLibrary/JDproductList/carInsurance/index.vue"
              ),
            meta: { title: "车险", icon: "arrow-right" },
          },
          {
            path: "nonmotorInsurance",
            component: () =>
              import(
                "@/components/productLibrary/JDproductList/nonmotorInsurance/index.vue"
              ),
            meta: { title: "非车险", icon: "arrow-right" },
          },
        ],
      },
      {
        path: "WXproductList",
        meta: { title: "网销渠道产品", icon: "arrow-right" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "lifeInsurance",
            component: () =>
              import(
                "@/components/productLibrary/WXproductList/lifeInsurance/index.vue"
              ),
            meta: { title: "人身险", icon: "arrow-right" },
          },
          {
            path: "carInsurance",
            component: () =>
              import(
                "@/components/productLibrary/WXproductList/carInsurance/index.vue"
              ),
            meta: { title: "车险", icon: "arrow-right" },
          },
          {
            path: "nonmotorInsurance",
            component: () =>
              import(
                "@/components/productLibrary/WXproductList/nonmotorInsurance/index.vue"
              ),
            meta: { title: "非车险", icon: "arrow-right" },
          },
        ],
      },
      {
        path: "sortManagement",
        meta: { title: "平台分类管理", icon: "arrow-right" },
        component: () =>
          import("@/components/productLibrary/sortManagement/index.vue"),
        children: [],
      },
      {
        path: "require",
        meta: { title: "产品需求管理", icon: "arrow-right" },
        component: () =>
          import("@/components/productLibrary/requireManagement/index.vue"),
        children: [],
      },
      {
        path: "dutyManagement",
        meta: { title: "责任管理", icon: "arrow-right" },
        component: () =>
          import("@/components/productLibrary/dutyManagement/index.vue"),
        children: [],
      },
      {
        path: "equitiesManagement",
        meta: { title: "权益管理", icon: "arrow-right" },
        component: () =>
          import("@/components/productLibrary/equitiesManagement/index.vue"),
        children: [],
      },
      {
        path: "activityManagement",
        meta: { title: "计划书活动量管理", icon: "arrow-right" },
        component: () =>
          import("@/components/productLibrary/activityManagement/index.vue"),
        children: [],
      },
    ],
  },
  //保单管理
  {
    path: "/policyManagement",
    component: Layout,
    meta: { title: "保单管理", icon: "people-fill" },
    children: [
      {
        path: "JDpolicy",
        meta: { title: "经代保单", icon: "arrow-right" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "lifeInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/lifeInsurance/index.vue"
              ),
            meta: { title: "人身险", icon: "arrow-right" },
          },
          {
            path: "quitLifeInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/quitLifeInsurance/index.vue"
              ),
            meta: { title: "人身险退保", icon: "arrow-right" },
          },
          {
            path: "renewalInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/renewalInsurance/index.vue"
              ),
            meta: { title: "人身险续期", icon: "arrow-right" },
          },
          {
            path: "group",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/groupInsurance/index.vue"
              ),
            meta: { title: "团意险情况", icon: "arrow-right" },
          },
          {
            path: "nonmotorInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/nonmotorInsurance/index.vue"
              ),
            meta: { title: "非车险", icon: "arrow-right" },
          },
          {
            path: "carInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/carInsurance/index.vue"
              ),
            meta: { title: "车险", icon: "arrow-right" },
          },
        ],
      },
      {
        path: "WXpolicy",
        meta: { title: "网销渠道产品", icon: "arrow-right" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "lifeInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/WXpolicy/lifeInsurance/index.vue"
              ),
            meta: { title: "人身险", icon: "arrow-right" },
          },

          {
            path: "nonmotorInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/WXpolicy/nonmotorInsurance/index.vue"
              ),
            meta: { title: "非车险", icon: "arrow-right" },
          },
          {
            path: "renewalInsurance",
            component: () =>
              import(
                "@/components/policyManagemen/JDpolicy/renewalInsurance/index.vue"
              ),
            meta: { title: "人身险续期", icon: "arrow-right" },
          },
        ],
      },
    ],
  },
  //订单管理
  {
    path: "/orderManagement",
    component: Layout,
    meta: { title: "订单管理", icon: "people-fill" },
    children: [
      {
        path: "policyBusiness",
        component: () =>
          import("@/components/orderManagement/policyBusiness/index"),
        meta: { title: "保单业务", icon: "arrow-right" },
      },
      {
        path: "weChatBusiness",
        component: () =>
          import("@/components/orderManagement/weChatBusiness/index"),
        meta: { title: "微信业务", icon: "arrow-right" },
      },
    ],
  },

  {
    path: "/coreManagement",
    component: Layout,
    redirect: "/coreManagement/insurance",
    meta: { title: "核心数据管理", icon: "people-fill" },
    children: [
      {
        path: "insurance",
        component: () =>
          import("@/components/coreManagement/insuranceManage/insurance"),
        meta: { title: "险种分类管理", icon: "arrow-right" },
        path: "brand",
        component: () =>
          import("@/components/productManagement/brandManage/brand"),
        meta: { title: "品牌管理", icon: "arrow-right" },
      },
    ],
  },

  {
    path: "/productManagement",
    component: Layout,
    redirect: "/productManagement/table",
    meta: { title: "产品管理", icon: "people-fill" },
    children: [
      {
        path: "/brand",
        component: () =>
          import("@/components/productManagement/brandManage/brand"),
        meta: { title: "品牌管理", icon: "arrow-right" },
      },
    ],
  },
  {
    path: "/organManage",
    component: Layout,
    redirect: "/organManage/settleDetail",
    meta: { title: "结算单", icon: "" },
    children: [
      {
        path: "/organManage/settleDetail",
        component: () =>
          import("@/components/organManagement/settlementManage/settleDetail"),
        meta: { title: "结算详情", icon: "" },
      },
    ],
  },
  //车险业务系统
  {
    path: "/carInsuranceSystem",
    component: Layout,
    redirect: "/carInsuranceSystem/carInsurance",
    meta: { title: "车险业务系统", icon: "archive-fill" },
    children: [
      {
        path: "carInsurance",
        component: () =>
          import(
            "../components/carInsuranceSystem/carInsurance/carInsurance.vue"
          ),
        meta: { title: "车险业务系统", icon: "arrow-right" },
      },
    ],
  },
  {
    path: "/fileView",
    name: "fileView",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/components/yulan/fileView.vue"),
  },
  //收支管理
  {
    path: "/incomeManage",
    component: Layout,
    meta: { title: "收支管理", icon: "people-fill" },
    children: [
      {
        path: "listImport",
        component: () =>
          import("@/components/incomeManagement/listImport/index"),
        meta: { title: "清单导入", icon: "arrow-right" },
      },
      {
        path: "allPolicy",
        component: () =>
          import("@/components/incomeManagement/allPolicy/index"),
        meta: { title: "所有保单", icon: "arrow-right" },
      },
      {
        path: "income",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: { title: "收入管理", icon: "arrow-right" },
        children: [
          {
            path: "insuranceCo",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: { title: "保险公司", icon: "arrow-right" },
            children: [
              {
                path: "noInvoiced",
                component: () =>
                  import(
                    "@/components/incomeManagement/inCome/noInvoiced/index"
                  ),
                meta: { title: "未开票", icon: "arrow-right" },
              },
              {
                path: "invoicing",
                component: () =>
                  import(
                    "@/components/incomeManagement/inCome/invoicing/index"
                  ),
                meta: { title: "开票中", icon: "arrow-right" },
              },
              {
                path: "open",
                component: () =>
                  import("@/components/incomeManagement/inCome/open/index"),
                meta: { title: "已开票", icon: "arrow-right" },
              },
              {
                path: "abolish",
                component: () =>
                  import("@/components/incomeManagement/inCome/abolish/index"),
                meta: { title: "作废发票", icon: "arrow-right" },
              },
            ],
          },
        ],
      },
    ],
  },
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js